var map = {
	"./avatar-00.webp": 7215,
	"./background-gradient.webp": 9937,
	"./balloon-00.webp": 8793,
	"./balloon-01.webp": 6308,
	"./balloon-02.webp": 2594,
	"./balloon-03.webp": 9247,
	"./balloon-04.webp": 6764,
	"./beebom-bottom.webp": 929,
	"./beebom-full.webp": 3890,
	"./beebom-mid.webp": 6583,
	"./city-back-00.webp": 7402,
	"./city-back-01.webp": 3996,
	"./city-front-00.webp": 9570,
	"./city-front-01.webp": 7525,
	"./footer-king-00.webp": 6107,
	"./footer-king-01.webp": 5774,
	"./footer-king-02.webp": 2377,
	"./footer-king.webp": 2795,
	"./laurels-00.webp": 8244,
	"./laurels-01.webp": 9131,
	"./laurels-02.webp": 4357,
	"./laurels-03.webp": 2361,
	"./laurels-04.webp": 2543,
	"./laurels-05.webp": 5038,
	"./laurels-06.webp": 6500,
	"./laurels-07.webp": 4050,
	"./laurels-big.webp": 5418,
	"./mine.webp": 4116,
	"./ribbon-purple.webp": 1416,
	"./ribbon-yellow.webp": 5611,
	"./screenshot-00-old.webp": 2043,
	"./screenshot-00.webp": 4500,
	"./screenshot-01-old.webp": 7781,
	"./screenshot-01.webp": 1634,
	"./video-frame.webp": 9469
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 468;